import customerLocale from 'modules/customer/presentation/locale';
import customerRoutes from 'modules/customer/presentation/routes';

const customerModule = {
  locale: customerLocale,
  routes: customerRoutes,
};

export default customerModule;
